import { Component, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { State, namespace } from 'vuex-class';
import ExtButton from '@/components/ext/Button.vue';
import {
  Breadcrumbs as BreadcrumbsLayout,
  Extra as ExtraLayout,
} from '@/components/layout';
import PageError from '../../404.vue';
import PageOrganization, {
  Props as PageOrganizationProps,
  SlotNames,
} from '@/components/page/organization';
import TabsMenu from '@/components/parts/tab/menu';
import {
  List as ProgramsList,
  Item as ProgramsItem,
  Items as ProgramsItems,
} from '@/components/parts/catalog/list';
import { TransitionFade } from '@/components/transition';
import convertEventsFromApi from '@/helpers/convertEventsFromApi';
import CommonMixin from '../common';
import { Breadcrumbs } from '../types';
import CardMixin from './common';
import { ACTION_FETCH, STORE_MODULE_NAME } from './const';
import createStoreModule from './store';
import {
  OrganizationExtended,
  Program,
  State as StateType,
  Statuses,
} from './types';

const { ERROR } = Statuses;
const Organization = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [ACTION_FETCH]);
const fetch = actions[ACTION_FETCH];

const isError = (value: any) => value === ERROR;

@Component({
  components: {
    BreadcrumbsLayout,
    ExtButton,
    ExtraLayout,
    PageError,
    PageOrganization,
    ProgramsList,
    TabsMenu,
    TransitionFade,
  },
  metaInfo() {
    const { title } = this as PageOrganizationCard;
    return { title };
  },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
})
export default class PageOrganizationCard extends Mixins(
  CardMixin,
  CommonMixin,
) {
  // Bindings
  @Organization.State
  status: StateType['status'];

  @Organization.State
  programs: StateType['programs'];

  @Organization.Getter
  full: OrganizationExtended;

  @State municipalities: Array<any>;

  // Readonly
  readonly bestProgramsTitle = 'Лучшие программы организации';
  readonly slotNames = SlotNames;

  // Computed
  get hasPrograms() {
    const { programsPrepared } = this;
    return programsPrepared && programsPrepared.length > 0;
  }
  get menu() {
    return [
      { title: 'Описание', to: { name: 'organization' } },
      { title: 'Помещения', to: { name: 'space' } },
      { title: 'Фото', to: { name: 'organization-photos' } },
      { title: 'Как добраться', to: { name: 'organization-map' } },
      //{ title: 'Педагоги', to: { name: 'organization-teachers' } },
      // { title: 'Отзывы', to: { name: 'organization-reviews' }},
    ];
  }

  get pageBinds(): PageOrganizationProps {
    const { contacts, id, logo, name } = this.organization;
    const { address, email, phone } = contacts;
    const { municipality } = this.full;
    return {
      address,
      email,
      logo,
      municipality: municipality && municipality.name,
      municipalityLink: {
        name: 'events',
        query: {
          municipality: String(municipality && municipality.id),
        },
      },
      name,
      phone,
      programsLink: {
        name: 'events',
        query: {
          municipality: String(municipality && municipality.id),
          organizer: String(id),
        },
      },
      vacanciesLink: {
        name: 'vacancies',
        query: {
          partner_id: String(id),
        },
      },
    };
  }

  get breadcrumbsExtended(): Breadcrumbs {
    const { organization } = this;
    const organizations = {
      text: 'Организации',
      to: { name: 'organizations' },
    };
    const result = [...this.breadcrumbs, organizations];
    if (organization) result.push({ text: organization.name });
    return result;
  }

  get hasError(): boolean {
    return isError(this.status);
  }

  get programsPrepared(): ProgramsItems {
    const { programs } = this;
    if (!programs) return [];

    return programs.map(convertEventsFromApi);
  }

  get title() {
    return this.organization.name;
  }

  // AsyncData
  async asyncData({ store, route }: any) {
    await fetch.call({ $store: store }, route.params);
  }
}



// WEBPACK FOOTER //
// ./src/pages/organizations/card/script.ts